import type { AdminJsonComponentConfig } from '@apps/websiteCustomJsonComponents/JsonComponent.types';
import { loadable } from '@shared/core/loadableFromNamedExport';
import { FaqGrabber } from './FaqSidebar';
import { FAQ_SCHEMA_URL, FAQ_COMPONENT_TYPE } from './Faq.constants';

// Lazy load view components
const FaqAdd = loadable(() => import(/* webpackChunkName: "content/websiteEditorFaqAdd" */ './FaqSidebar'), 'FaqAdd');

const FaqEdit = loadable(() => import(/* webpackChunkName: "content/websiteEditorFaqEdit" */ './components/FaqEdit'), 'FaqEdit');

// Add this object to CUSTOM_JSON_COMPONENT_TYPES in
// src/apps/websiteCustomJsonComponents/config.ts
export const FaqConfig: AdminJsonComponentConfig = {
  schemaUrl: FAQ_SCHEMA_URL,
  componentType: FAQ_COMPONENT_TYPE,
  adminSidebarComponent: {
    addComponentView: FaqAdd,
    dragComponentView: FaqGrabber,
    editComponentView: FaqEdit,
    createComponentView: FaqEdit,
  },
} as const;
